import PropTypes from 'prop-types'
import SavedStateIndicator from '../../reusables/SavedStateIndicator'
import { cn } from '../../../utils/index.js'

export default function CueTimingSchaffold({
  className = '',
  style,
  sup,
  top,
  bottom,
  sub,
  loading,
  children,
}) {
  return (
    <div
      className={cn(
        'relative w-28 pb-6 flex-none flex flex-col justify-stretch items text-center',
        className,
      )}
      style={style}
    >
      <div className="pt-8 w-full relative">
        <div className="absolute h-5 top-0 w-full">{sup}</div>
      </div>
      <div className="z-2 sticky top-35 flex-none min-h-max max-h-full h-6 w-full px-1">
        <div className="absolute h-4 -top-5 bottom-0 left-1/2 -translate-x-1/2 max-w-full">
          {top}
        </div>
        {children}
      </div>
      {/* z-index important for above element being clickable on scroll */}
      <div className="flex-1 z-1 w-full relative">
        <div className="absolute h-4 top-0 left-1/2 -translate-x-1/2 max-w-full">
          {bottom}
        </div>
        <div className="absolute h-5 -bottom-6 w-full">{sub}</div>
      </div>
      <SavedStateIndicator
        className="absolute z-30 bottom-1 right-1"
        saving={loading}
      />
    </div>
  )
}

CueTimingSchaffold.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  sup: PropTypes.any,
  top: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
  bottom: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
  sub: PropTypes.any,
  loading: PropTypes.bool,
  children: PropTypes.any,
}
